/**
 * AgentSignUpPage - Dedicated page for agent registration
 * Used for testing agent signup flow separately from agencies
 */

import AgentSignUpForm from "@/global/components/forms/AgentSignUpForm";

export default function AgentSignUpPage() {
  return (
    <div className="min-h-screen bg-linear-to-br from-background to-secondary/20 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <AgentSignUpForm />
      </div>
    </div>
  );
}